import type { Dtos } from "@inrev/common";
import { useQuery } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { fredSeriesRangeQueryKey } from "../fred.keys";

/** Fetches full observations because snapshot sparklines are too heavily downsampled for charts. */
export const useFetchFredSeries = (seriesCode: string, from?: string, to?: string) => {
	const { get } = useRequest();

	return useQuery({
		queryKey: fredSeriesRangeQueryKey(seriesCode, from, to),
		queryFn: async () => {
			const params = new URLSearchParams();
			if (from !== undefined) params.append("from", from);
			if (to !== undefined) params.append("to", to);
			const query = params.toString();

			return await get<Dtos.MarketIntelligence.Fred.GetSeries.Response>(
				`/v2/admin/market-intelligence/fred/series/${encodeURIComponent(seriesCode)}${query === "" ? "" : `?${query}`}`,
			);
		},
	});
};
